import { PickOrderSummaryFragment } from '../../../graphql'

/**
 * The soonest any order in the run is needed — the date that decides which run
 * to pick first. Dates are calendar days (`YYYY-MM-DD`), so they compare as strings.
 */
export function earliestNeededBy( orders: Pick<PickOrderSummaryFragment['fulfillmentOrders'][number], 'dateNeededBy'>[] ): string | null {
	const dates = orders.map( ( order ) => order.dateNeededBy ).filter( ( date ): date is string => !!date )
	return dates.length === 0 ? null : [ ...dates ].sort( ( a, b ) => a.localeCompare( b ) )[ 0 ]
}

/** `3 products · 24 units`. Products, not lines: two orders wanting one product are one stop. */
export function runSize( lines: Pick<PickOrderSummaryFragment['lines'][number], 'productId' | 'quantityToPick'>[] ): string {
	const products = new Set( lines.map( ( line ) => String( line.productId ) ) ).size
	const units = lines.reduce( ( sum, line ) => sum + line.quantityToPick, 0 )
	return `${products} ${products === 1 ? 'product' : 'products'} · ${units} ${units === 1 ? 'unit' : 'units'}`
}

/**
 * A calendar date as the reader's locale writes it. Parsed as UTC and printed
 * as UTC, so `2026-10-01` never shows as the 30th west of Greenwich.
 */
export function formatDate( date: string | null | undefined ): string | null {
	if ( !date ) {
		return null
	}
	return new Date( `${date.slice( 0, 10 )}T00:00:00Z` ).toLocaleDateString( undefined, { timeZone: 'UTC' } )
}

export function formatDateTime( timestamp: string | null | undefined ): string {
	return timestamp ? new Date( timestamp ).toLocaleString( undefined, { dateStyle: 'short', timeStyle: 'short' } ) : '—'
}
